import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import PageView from 'front/components/PageView/PageView.js'
import About from 'front/components/About/About.js'
import Hero from 'front/components/Hero/Hero.js'
import Video from 'front/components/Video/Video.js'
import PageTitle from 'front/components/PageTitle/PageTitle.js'

import './AboutPage.css'
import template from './AboutPage.jinja'


var AboutPage = PageView.extend({
    el: '.AboutPage',

    type: 'About',

    template: template,

    apiUrl: '/api/pages/about/',

    initialize (options) {
        _.bindAll(this, '_scrollListener', 'animateHeader')

        this.state = new Backbone.Model({inside: false})
        this.scrollListener = _.throttle(this._scrollListener, 100)

        PageView.prototype.initialize.call(this, options)
    },

    _scrollListener() {
        let scrollTop = app.els.$window.scrollTop()

        if (scrollTop / app.els.$window.height() > 0.3) {
            if (!this.state.get('inside')) {
                this.state.set('inside', true)
            }
        } else {
            if (this.state.get('inside')) {
                this.state.set('inside', false)
            }
        }
    },

    animateHeader(state) {
        if (state.get('inside')) {
            app.views.nav.minimize()
            app.views.langs.deactivate()
            this.pageTitle.$el.hide()
            this.hero.deactivateArrow()
        } else {
            app.views.nav.maximize()
            app.views.langs.activate()
            this.pageTitle.$el.show()
            this.hero.activateArrow()
        }
    },

    playIn() {
        this.pageTitle.playIn()
            .then(() => {
                return this.video.playIn()
            })
            .then(() => {
                app.views.nav.activate({fixed: true});
                app.views.cookie.activate();
                this.hero.activateFrame()
                app.views.logo.activate({delay: 500})
                this.hero.activateArrow()
                return app.views.langs.activate({delay: 500})
            })
            .then(() => {
                app.els.$body.removeClass('u-NoOverflow')

                this.listenTo(this.state, 'change:inside', this.animateHeader)
                app.els.$window.on('scroll', this.scrollListener)
            })
    },

    playOut() {
        app.views.langs.deactivate()
        app.views.logo.deactivate()

        return Promise.resolve(this.hero.deactivateImage())
            .then(() => {
                this.pageTitle.playOut()
                return app.views.nav.deactivate()
            })
    },

    prepare () {
        this.$el[0].style.display = 'block'

        this.$video = this.$('.Video')

        this.about = this.views.about = new About()

        this.pageTitle = this.views.pageTitle = new PageTitle({
            el: this.$('.PageTitle')
        })

        this.hero = this.views.hero = new Hero({
            el: this.$('.Hero')
        })

        this.video = this.views.video = new Video({
            el: this.$video
        })

        $.Velocity.hook(this.$video, 'opacity', '0')
        $.Velocity.hook(this.pageTitle.$el, 'opacity', '0')
        $.Velocity.hook(this.hero.$img, 'opacity', '0')

        this.hero.$arrow.addClass('isNotActive isNotTransitioned')
        this.hero.$frame.addClass('isNotActive')

        return this.preloadImages()
            .then(() => {
                //return this.video.activate()
            })
            .then(() => {
                return this.promise
            })
            .then(() => {
                app.els.$window.scrollTop(0)
                return app.loader.deactivate()
            })
    },

    cleanUp () {
        app.els.$window.off('scroll', this.scrollListener)
        app.els.$body.addClass('u-NoOverflow')
        this.close()
        return app.loader.activate()
    }
})

export default AboutPage



// WEBPACK FOOTER //
// ./assets/app/front/pages/AboutPage/AboutPage.js